import React from 'react';
import {
  Container,
  Typography,
  Paper,
  Stepper,
  Step,
  StepLabel,
} from '@mui/material';
import { useUploadWizard } from '../../contexts/UploadWizardContext';
import { UploadStep } from '../../types/upload';
import WizardNavigation from './wizard/WizardNavigation';
import FileSelectionStep from './wizard/FileSelectionStep';
import ProductionSelectionStep from './wizard/ProductionSelectionStep';
import IndividualMetadataStep from './wizard/IndividualMetadataStep';
import TagStep from './wizard/TagStep';
import ReviewUploadStep from './wizard/ReviewUploadStep';

const StepWizardUpload: React.FC = () => {
  const { currentStep, state } = useUploadWizard();

  const getStepLabel = (step: UploadStep): string => {
    switch (step) {
      case UploadStep.FILE_SELECTION:
        return 'Select Files';
      case UploadStep.PRODUCTION_SELECTION:
        return 'Production ID';
      case UploadStep.INDIVIDUAL_METADATA:
        return 'Metadata & Grouping';
      case UploadStep.TAG:
        return 'Tag Creatives';
      case UploadStep.REVIEW_UPLOAD:
        return 'Review & Upload';
      default:
        return '';
    }
  };

  const getStepIndex = (step: UploadStep): number => {
    const allSteps = [
      UploadStep.FILE_SELECTION,
      UploadStep.PRODUCTION_SELECTION,
      UploadStep.INDIVIDUAL_METADATA,
      UploadStep.TAG,
      UploadStep.REVIEW_UPLOAD
    ];
    return allSteps.indexOf(step);
  };

  const getAllSteps = (): UploadStep[] => {
    return [
      UploadStep.FILE_SELECTION,
      UploadStep.PRODUCTION_SELECTION,
      UploadStep.INDIVIDUAL_METADATA,
      UploadStep.TAG,
      UploadStep.REVIEW_UPLOAD
    ];
  };

  const renderCurrentStep = () => {
    switch (currentStep) {
      case UploadStep.FILE_SELECTION:
        return <FileSelectionStep />;
      case UploadStep.PRODUCTION_SELECTION:
        return <ProductionSelectionStep />;
      case UploadStep.INDIVIDUAL_METADATA:
        return <IndividualMetadataStep />;
      case UploadStep.TAG:
        return <TagStep />;
      case UploadStep.REVIEW_UPLOAD:
        return <ReviewUploadStep />;
      default:
        return <div>Unknown step</div>;
    }
  };

  const allSteps = getAllSteps();
  const activeStepIndex = getStepIndex(currentStep);

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h3" component="h1" gutterBottom align="center">
        Upload Creative Ads
      </Typography>
      
      <Typography variant="body1" color="text.secondary" align="center" sx={{ mb: 4 }}>
        Keeping your ads in the family
      </Typography>

      {/* Progress Stepper */}
      <Paper elevation={1} sx={{ p: 3, mb: 4 }}>
        <Stepper activeStep={activeStepIndex} alternativeLabel>
          {allSteps.map((step) => (
            <Step key={step} completed={state.stepValidation[step]}>
              <StepLabel
                error={false} // We can add error state later if needed
              >
                {getStepLabel(step)}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </Paper>

      {/* Current Step Content */}
      <Paper elevation={2} sx={{ mb: 4, minHeight: '400px' }}>
        {renderCurrentStep()}
      </Paper>

      {/* Navigation */}
                    <WizardNavigation />
    </Container>
  );
};

export default StepWizardUpload;